// extracted by mini-css-extract-plugin
export default {"image":"Intro__image--1tNPS","content":"Intro__content--1wV0I"};